module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu app-sidebar overflow-hidden",
    class: {
      'hide-sidebar': !_vm.showSidebarDesktop && !_vm.showSidebarMobile, 'is-mobile': _vm.showSidebarMobile
    }
  }, [_c('div', {
    staticClass: "menu-label"
  }, [(!_vm.showSidebarDesktop && !_vm.showSidebarMobile) ? _c('span', [_vm._v("SS")]) : [(_vm.pathFoto) ? _c('div', {
    staticClass: "flex fdc aic"
  }, [_c('div', {
    staticClass: "avatar mb-10"
  }, [_c('img', {
    attrs: {
      "src": _vm.pathFoto
    }
  })]), _c('span', {
    staticClass: "fs-14"
  }, [_vm._v("Self Service")])]) : _c('span', [_vm._v("Self Service")])]], 2), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.isLoadingMenu) ? _c('ul', {
    staticClass: "menu-list overflow-y-scroll"
  }, [_c('transition-group', {
    staticClass: "contenedor-sidebar",
    attrs: {
      "name": "fade-smooth",
      "tag": "div"
    }
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      key: 'menu_item_' + index,
      attrs: {
        "title": item.name
      }
    }, [(item.path) ? [_c('router-link', {
      staticClass: "has-text-left router-link ai-center",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'router-item' : '',
      attrs: {
        "to": item.path
      }
    }, [_c('span', {
      staticClass: "icon is-small",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'margin-right-0' : ''
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    })]), (_vm.showSidebarDesktop || _vm.showSidebarMobile) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), (item.key === 'vacaciones') ? [(_vm.datos.diasVacaciones) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.datos.diasVacaciones + ' dias por tomar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.datos.diasVacaciones))])]) : _vm._e()] : _vm._e(), (item.key === 'mis-documentos-firmar') ? [(_vm.documentosPorFirmar) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.documentosPorFirmar + ' documentos sin firmar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.documentosPorFirmar))])]) : _vm._e()] : _vm._e(), (item.key === 'mis-contratos') ? [(_vm.contratosPorFirmar) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.contratosPorFirmar + ' contratos sin firmar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.contratosPorFirmar))])]) : _vm._e()] : _vm._e(), (item.key === 'mis-cursos') ? [(_vm.cursosSinTerminar) ? _c('div', {
      staticClass: "badge",
      attrs: {
        "title": _vm.cursosSinTerminar + ' cursos sin terminar'
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.cursosSinTerminar))])]) : _vm._e()] : _vm._e()], 2), (!_vm.showSidebarDesktop) ? _c('hr', {
      staticClass: "margin-0"
    }) : _vm._e()] : [_c('a', {
      staticClass: "has-text-left ai-center position-relative",
      class: {
        open: item.showChildren, 'router-item': !_vm.showSidebarDesktop && !_vm.showSidebarMobile
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          item.showChildren = !item.showChildren
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'margin-left-20' : ''
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    })]), (_vm.showSidebarDesktop) ? _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]) : _vm._e(), _c('span', {
      staticClass: "icon is-small is-angle left-85",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'margin-right--4' : ''
    }, [_c('i', {
      staticClass: "fa fa-angle-down"
    })])]), _c('transition', {
      attrs: {
        "name": "fade-smooth"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showChildren),
        expression: "item.showChildren"
      }],
      staticClass: "children"
    }, [_c('ul', {
      staticClass: "menu-list",
      class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'menu-list-hide' : ''
    }, _vm._l((item.children), function(itemChildren, indexChildren) {
      return _c('li', [_c('router-link', {
        key: itemChildren.key,
        staticClass: "has-text-left router-link",
        class: !_vm.showSidebarDesktop && !_vm.showSidebarMobile ? 'router-item' : '',
        attrs: {
          "to": itemChildren.path
        }
      }, [(!_vm.showSidebarDesktop && !_vm.showSidebarMobile) ? _c('span', {
        staticClass: "icon is-small",
        attrs: {
          "title": itemChildren.name
        }
      }, [_c('i', {
        staticClass: "fa",
        class: itemChildren.icon
      })]) : _vm._e(), (_vm.showSidebarDesktop) ? _c('span', {
        staticClass: "name"
      }, [_vm._v(_vm._s(itemChildren.name))]) : _vm._e(), (itemChildren.key === 'vacaciones') ? [(_vm.datos.diasVacaciones) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.datos.diasVacaciones + ' dias para gozar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.datos.diasVacaciones))])]) : _vm._e()] : _vm._e(), (itemChildren.key === 'mis-documentos-firmar') ? [(_vm.documentosPorFirmar) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.documentosPorFirmar + ' documentos sin cargar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.documentosPorFirmar))])]) : _vm._e()] : _vm._e(), (itemChildren.key === 'mis-contratos') ? [(_vm.contratosPorFirmar) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.contratosPorFirmar + ' contratos sin cargar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.contratosPorFirmar))])]) : _vm._e()] : _vm._e(), (itemChildren.key === 'mis-cursos') ? [(_vm.cursosSinTerminar) ? _c('div', {
        staticClass: "badge",
        attrs: {
          "title": _vm.cursosSinTerminar + ' cursos sin terminar'
        }
      }, [_c('span', [_vm._v(_vm._s(_vm.cursosSinTerminar))])]) : _vm._e()] : _vm._e()], 2)], 1)
    }), 0)])]), (!_vm.showSidebarDesktop && !_vm.showSidebarMobile) ? _c('hr', {
      staticClass: "margin-0"
    }) : _vm._e()]], 2)
  }), 0)], 1) : _c('div', {
    staticClass: "loading-short"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-circle-o-notch fa-spin"
  })]), _vm._v("Cargando el menu")])]), ((!(_vm.estoyReemplazando || _vm.estoySiendoReemplazado) && (_vm.perfilUsuario === 'jefe' || _vm.perfilUsuario === 'recursos humanos'))) ? _c('div', {
    staticClass: "menu-label-bgcolor button-delegacion",
    on: {
      "click": _vm.abrirDelegacion
    }
  }, [_c('span', [_vm._v("Definir Reemplazo")]), _c('i', {
    staticClass: "fa fa-plane"
  })]) : _vm._e(), (_vm.isUserBirthday) ? _c('div', {
    staticClass: "menu-label-bgcolor"
  }, [_c('span', [_vm._v("¡Feliz cumpleaños! ")]), _c('i', {
    staticClass: "fa fa-birthday-cake ml-5s"
  })]) : _vm._e(), ((_vm.estoyReemplazando || _vm.estoySiendoReemplazado) && _vm.showSidebarMobile) ? _c('div', {
    staticClass: "delegaciones"
  }, [_c('delegaciones-mostrar-reemplazo', {
    attrs: {
      "isMobile": _vm.showSidebarMobile
    }
  })], 1) : _vm._e(), (_vm.showSidebarDesktop || _vm.showSidebarMobile) ? _c('div', {
    staticClass: "menu-label-name"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.datos.nombre))])])]) : _vm._e(), (_vm.showSidebarMobile) ? _c('div', {
    staticClass: "menu-label-name salir",
    on: {
      "click": _vm.logout
    }
  }, [_c('span', [_c('strong', [(_vm.isSaliendo) ? [_vm._v("Saliendo "), _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })] : [_vm._v("Salir")]], 2)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b89ea72","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 879
// module chunks = 0